import { Config } from '@leverege/plugin';
import { Button, Content, Flex, Pane, Text } from '@leverege/ui-elements';
import { TitleBar } from '@leverege/ui-plugin';
import { useMediaQuery } from 'react-responsive';
import I18N from '@leverege/i18n';
import { connect } from 'react-redux';
import { LocationAlertsModel } from '@leverege/recovr-models';
import { useEffect } from 'react';
import { getVehicleUsageTypes } from '../util/Model';
import S from './BillingPortalScreen.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = I18N.ns('recovr.billingPortal.BillingPortalScreen');
function BillingPortalScreen(props) {
  const {
    setTitle,
    setIcon,
    parentItem
  } = props;
  const icon = Config.get('BillingPortal', 'screenIcon', t('icon'));

  // updates the title and icon in mobile view
  useEffect(() => {
    if (setTitle) setTitle({
      data: 'Billing'
    });
    if (setIcon) {
      setIcon({
        data: Config.get('BillingPortal', 'screenIcon', icon)
      });
    }
  }, [setTitle, setIcon, parentItem, icon]);
  const locationBillingPortalDate = new Date(parentItem?.data?.data?.billingPortalDate);
  const billingPortalDateFormatted = locationBillingPortalDate.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  });
  const isMobile = useMediaQuery({
    query: '(max-width: 430px)'
  });
  return /*#__PURE__*/_jsxs(Content, {
    children: [!isMobile && /*#__PURE__*/_jsx(Content.Header, {
      children: /*#__PURE__*/_jsx(TitleBar, {
        variant: "screenTitle",
        title: t('navTitle'),
        icon: icon
      })
    }), /*#__PURE__*/_jsx(Content.Area, {
      variant: "formBody",
      className: S.contentArea,
      children: /*#__PURE__*/_jsxs(Flex, {
        variant: isMobile ? 'col' : 'row',
        align: "center",
        justify: "center",
        className: S.container,
        children: [/*#__PURE__*/_jsx(Pane, {
          inline: true,
          className: S.billingIconContainer,
          children: /*#__PURE__*/_jsx("img", {
            src: t('billingPortalIcon'),
            alt: "Billing Portal Icon",
            className: S.billingIcon
          })
        }), /*#__PURE__*/_jsxs(Flex, {
          variant: "col",
          justify: "flex-start",
          className: S.description,
          children: [/*#__PURE__*/_jsx(Text, {
            variant: "title",
            children: t('title')
          }), /*#__PURE__*/_jsx(Text, {
            variant: "bodyNormal",
            children: t('description', {
              billingPortalDateFormatted
            })
          }), /*#__PURE__*/_jsx(Flex, {
            variant: "row",
            className: S.buttonContainer,
            children: /*#__PURE__*/_jsxs(Button, {
              variant: "primary",
              onClick: () => window.open(t('link')),
              children: [t('linkText'), /*#__PURE__*/_jsx("img", {
                src: t('linkIcon'),
                alt: "Billing Portal Link Icon"
              })]
            })
          })]
        })]
      })
    })]
  });
}
const mapStateToProps = (state, props) => {
  const {
    parentItem
  } = props;
  const vehicleTypeValues = getVehicleUsageTypes(state).map(usageType => usageType.value);
  const EMPTY_MODEL = LocationAlertsModel({
    vehicleTypes: vehicleTypeValues
  }).create();
  return {
    locationAlerts: parentItem?.data?.metadata?.locationAlerts || EMPTY_MODEL
  };
};
export default connect(mapStateToProps)(BillingPortalScreen);